export const CONTACT_US = "https://beta.measurable.ai:8080/v1/api/contactus";

export const SUBSCRIBE = "https://beta.measurable.ai:8080/v1/api/subscribe";
